import { useEffect, useState } from "react";
import { Sun, Moon } from "lucide-react";

// Thème clair / foncé : mémorisé dans le navigateur (clé aca_theme) et appliqué
// via la classe `aca-light` sur <html> (voir index.css). Le bouton propose
// toujours l'AUTRE thème : « Thème clair » en mode foncé, « Thème foncé » en mode clair.
const KEY = "aca_theme";

export function applyTheme(mode) {
  document.documentElement.classList.toggle("aca-light", mode === "light");
}

// Appelé au démarrage (index.js) pour réappliquer le choix mémorisé sur toutes les pages.
export function initTheme() {
  try { applyTheme(localStorage.getItem(KEY) === "light" ? "light" : "dark"); } catch { /* mode foncé par défaut */ }
}

export default function ThemeSection({ testid = "theme" }) {
  const [light, setLight] = useState(() => {
    try { return localStorage.getItem(KEY) === "light"; } catch { return false; }
  });
  useEffect(() => {
    applyTheme(light ? "light" : "dark");
    try { localStorage.setItem(KEY, light ? "light" : "dark"); } catch { /* stockage indisponible */ }
  }, [light]);

  return (
    <div className="border-t border-white/10 px-6 py-4" data-testid={`${testid}-section`}>
      <div className="text-[10px] uppercase tracking-[0.2em] text-ink-tertiary">Thème</div>
      <button onClick={() => setLight((v) => !v)} data-testid={`${testid}-toggle`}
        title={light ? "Repasser au thème foncé" : "Passer au thème clair"}
        className="mt-2 flex w-full items-center gap-3 text-sm text-ink-secondary transition-colors hover:text-white">
        {light ? <Moon size={18} className="text-cyan" /> : <Sun size={18} className="text-cyan" />}
        {light ? "Thème foncé" : "Thème clair"}
      </button>
    </div>
  );
}
